import { render, staticRenderFns } from "./NewLayout.vue?vue&type=template&id=9e00b070&scoped=true"
import script from "./NewLayout.vue?vue&type=script&lang=js"
export * from "./NewLayout.vue?vue&type=script&lang=js"
import style0 from "./NewLayout.vue?vue&type=style&index=0&id=9e00b070&prod&lang=scss&scoped=true"
import style1 from "./NewLayout.vue?vue&type=style&index=1&id=9e00b070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e00b070",
  null
  
)

export default component.exports